import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';
import { minutes } from '~/shared/utils/helpers';

type Args = {
    signal: AbortSignal | undefined;
    customerId: string | null;
    token: string | null;
};

export default function getMyOrders({ signal, customerId, token }: Args) {
    if (!customerId) {
        return Promise.reject(new Error(shopErrors.orderDetails.message));
    }
    const url = getUrl(`/customers/${customerId}/orders`);

    return shop
        .get(url, {
            signal,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            timeout: minutes(1),
        })
        .json<ShopTypes.OrderHeader[]>();
}
